<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\changeAvaManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào tài khoản bên cạnh ảnh đại diện, rồi nhấn vào icon [Thông tin cá nhân].</p>
                </div>
                <div><img src="/static\images\vi\newManual\changeAvaManual-2.png" alt="" /></div>
                <div>
                    <p>② Nhấn vào hình đại diện.</p>
                </div>
                <div><img src="/static\images\vi\newManual\changeAvaManual-3.png" alt="" /></div>
                <div>
                    <p>③ Nhấn vào nút [Lựa chọn hình ảnh], rồi chọn hình ảnh muốn dùng làm hình đại diện.</p>
                </div>
                <div><img src="/static\images\vi\newManual\changeAvaManual-4.png" alt="" /></div>
                <div>
                    <p>④ Nhấn nút [Lưu].</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/en/changeAva_manual.vue